import axios from '../utils/axios';

export const getDpaStatus = async () => {
  const { data } = await axios.get('/api/my-pages/dpa/status');
  return data;
};

export const acceptDpa = async (version) => {
  const { data } = await axios.post('/api/my-pages/dpa/accept', { version });
  return data;
};

export const getDpaAgreement = async () => {
  const { data } = await axios.get('/api/my-pages/dpa/agreement');
  return data;
};

export const getDpaHistory = async () => {
  const { data } = await axios.get('/api/my-pages/dpa/history');
  return data;
};

export const getDpaAdminOverview = async (params = {}) => {
  try {
    const queryString = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        queryString.append(key, value);
      }
    });
    const { data } = await axios.get(`/api/my-pages/dpa/admin/overview?${queryString}`);
    return data;
  } catch (error) {
    console.error('Error fetching DPA admin overview:', error);
    throw error;
  }
};

export const adminAcceptDpa = async (companyName) => {
  try {
    const { data } = await axios.post('/api/my-pages/dpa/admin/accept', { companyName });
    return data;
  } catch (error) {
    console.error('Error accepting DPA for company:', error);
    throw error;
  }
};

export const adminRevokeDpa = async (companyName) => {
  try {
    const encodedName = encodeURIComponent(companyName);
    const { data } = await axios.delete(`/api/my-pages/dpa/admin/revoke/${encodedName}`);
    return data;
  } catch (error) {
    console.error('Error revoking DPA for company:', error);
    throw error;
  }
};

export const adminExemptDpa = async (companyName, reason) => {
  try {
    const { data } = await axios.post('/api/my-pages/dpa/admin/exempt', { companyName, reason });
    return data;
  } catch (error) {
    console.error('Error exempting company from DPA:', error);
    throw error;
  }
};

export const adminRemoveExemptDpa = async (companyName) => {
  try {
    const encodedName = encodeURIComponent(companyName);
    const { data } = await axios.delete(`/api/my-pages/dpa/admin/exempt/${encodedName}`);
    return data;
  } catch (error) {
    console.error('Error removing DPA exemption for company:', error);
    throw error;
  }
};
